export default __webpack_public_path__ + "static/media/Toyota.d194dc63.png";